// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from 'D:/a/1/s/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'D:/a/1/s/src/layouts/BlankLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/confirmAccount",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'D:/a/1/s/src/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'D:/a/1/s/src/pages/user/login'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login__confirm-account' */'D:/a/1/s/src/pages/user/login/confirm-account'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "path": "/s",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External___layout' */'D:/a/1/s/src/pages/External/_layout'), loading: LoadingComponent}),
        "hideInMenu": true,
        "hideChildrenInMenu": true,
        "exact": false,
        "routes": [
          {
            "path": "/s/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Redirect' */'D:/a/1/s/src/pages/External/Redirect'), loading: LoadingComponent}),
            "pattern": ":id",
            "exact": true
          }
        ]
      },
      {
        "path": "/p",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyPortal' */'D:/a/1/s/src/pages/CompanyPortal'), loading: LoadingComponent}),
        "hideInMenu": true,
        "hideChildrenInMenu": true,
        "exact": false,
        "routes": [
          {
            "path": "/p/:companyCode/:processPortalCode",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'D:/a/1/s/src/layouts/BasicLayout'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/external",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External___layout' */'D:/a/1/s/src/pages/External/_layout'), loading: LoadingComponent}),
        "hideInMenu": true,
        "hideChildrenInMenu": true,
        "exact": false,
        "routes": [
          {
            "path": "/external/request-handle",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Handle' */'D:/a/1/s/src/pages/External/Handle'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/external/request-start/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Public' */'D:/a/1/s/src/pages/External/Public'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/external/request-continue",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Request' */'D:/a/1/s/src/pages/External/Request'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Request__Continue' */'D:/a/1/s/src/pages/External/Request/Continue'), loading: LoadingComponent}),
                "exact": false
              }
            ]
          },
          {
            "path": "/external/request-view",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Request' */'D:/a/1/s/src/pages/External/Request'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Request__Details' */'D:/a/1/s/src/pages/External/Request/Details'), loading: LoadingComponent}),
                "exact": false
              }
            ]
          },
          {
            "path": "/external/request-approve",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Request' */'D:/a/1/s/src/pages/External/Request'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/external/request-reject",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Request' */'D:/a/1/s/src/pages/External/Request'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/external/telegram-authorize",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__External__Telegram' */'D:/a/1/s/src/pages/External/Telegram'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/external/400",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__400' */'D:/a/1/s/src/pages/400'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'D:/a/1/s/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/user",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'D:/a/1/s/src/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/user",
            "redirect": "/user/login",
            "exact": true
          },
          {
            "path": "/user/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'D:/a/1/s/src/pages/user/login'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/forgot-password",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login__forgot-password' */'D:/a/1/s/src/pages/user/login/forgot-password'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/reset-password",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login__reset-password' */'D:/a/1/s/src/pages/user/login/reset-password'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/two-factor",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login__two-factor' */'D:/a/1/s/src/pages/user/login/two-factor'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/two-factor/security-code",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login__verify-code' */'D:/a/1/s/src/pages/user/login/verify-code'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/sso-redirect",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login__sso-redirect' */'D:/a/1/s/src/pages/user/login/sso-redirect'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/user/login/access-blocked",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login__access-blocked' */'D:/a/1/s/src/pages/user/login/access-blocked'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/user/rpa-auth-success",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__rpa-auth-success' */'D:/a/1/s/src/pages/user/rpa-auth-success'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'D:/a/1/s/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/support",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'D:/a/1/s/src/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/support",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__support' */'D:/a/1/s/src/pages/user/support'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/billing/payment-setup",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'D:/a/1/s/src/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/billing/payment-setup",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__payment-setup' */'D:/a/1/s/src/pages/billing/payment-setup'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/billing/payment-setup/success",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__payment-setup__success' */'D:/a/1/s/src/pages/billing/payment-setup/success'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/billing/payment-setup/cancel",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__payment-setup__cancel' */'D:/a/1/s/src/pages/billing/payment-setup/cancel'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/billing/payment",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'D:/a/1/s/src/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/billing/payment",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__payment' */'D:/a/1/s/src/pages/billing/payment'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/billing/payment/success",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__payment__success' */'D:/a/1/s/src/pages/billing/payment/success'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/billing/payment/cancel",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__payment__cancel' */'D:/a/1/s/src/pages/billing/payment/cancel'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/apps/:id",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__apps__AppGateway' */'D:/a/1/s/src/pages/apps/AppGateway'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'D:/a/1/s/src/layouts/BasicLayout'), loading: LoadingComponent}),
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'D:/a/1/s/src/pages/Authorized'), loading: LoadingComponent})],
        "routes": [
          {
            "path": "/exception/403",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__403' */'D:/a/1/s/src/pages/403'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "home",
            "icon": "Home-filled",
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home' */'D:/a/1/s/src/pages/Home'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/billing/checkout/success",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__checkout__CheckoutResultView' */'D:/a/1/s/src/pages/billing/checkout/CheckoutResultView'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true,
            "authority": [
              "admin",
              "super-admin"
            ]
          },
          {
            "path": "/billing/checkout/cancel",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__billing__checkout__CheckoutResultView' */'D:/a/1/s/src/pages/billing/checkout/CheckoutResultView'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true,
            "authority": [
              "admin",
              "super-admin"
            ]
          },
          {
            "path": "/dashboard-classic",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Overview' */'D:/a/1/s/src/pages/Overview'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "embedTemplate",
            "path": "/embed",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyPortal__Embed' */'D:/a/1/s/src/pages/CompanyPortal/Embed'), loading: LoadingComponent}),
            "exact": true,
            "hideInMenu": true
          },
          {
            "name": "embedTemplate",
            "path": "/e/:menuSlug",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyPortal__Embed' */'D:/a/1/s/src/pages/CompanyPortal/Embed'), loading: LoadingComponent}),
            "exact": true,
            "hideInMenu": true
          },
          {
            "name": "renderTemplate",
            "path": "/render-template",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyPortal__RenderTemplate' */'D:/a/1/s/src/pages/CompanyPortal/RenderTemplate'), loading: LoadingComponent}),
            "exact": true,
            "hideInMenu": true
          },
          {
            "name": "renderTemplate",
            "path": "/r/:menuSlug",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyPortal__RenderTemplate' */'D:/a/1/s/src/pages/CompanyPortal/RenderTemplate'), loading: LoadingComponent}),
            "exact": true,
            "hideInMenu": true
          },
          {
            "name": "processes",
            "icon": "Device-hub",
            "path": "/processes",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__Home' */'D:/a/1/s/src/pages/Process/Home'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "config",
                "path": "/processes/v1Config",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__v1ConfigURL' */'D:/a/1/s/src/pages/Process/v1ConfigURL'), loading: LoadingComponent}),
                "exact": true,
                "hideInMenu": true
              },
              {
                "name": "start",
                "path": "/processes/start",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-start' */'D:/a/1/s/src/pages/Process/process-start'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "details",
                "path": "/processes/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__GroupDetail' */'D:/a/1/s/src/pages/Process/GroupDetail'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": false,
                "pattern": ":id"
              }
            ]
          },
          {
            "name": "tasks",
            "icon": "Update",
            "path": "/tasks",
            "key": "tasks",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__tasks-modern' */'D:/a/1/s/src/pages/tasks-modern'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/tasks-classic",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Provider' */'D:/a/1/s/src/pages/Provider'), loading: LoadingComponent}),
            "hideInMenu": true,
            "routes": [
              {
                "path": "/tasks-classic",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__tasks' */'D:/a/1/s/src/pages/tasks'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "applications",
            "icon": "Offline-bolt",
            "path": "/applications",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__applications-modern' */'D:/a/1/s/src/pages/applications-modern'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "details",
                "path": "/applications/detailsByActionInstance",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__applications__application-detail' */'D:/a/1/s/src/pages/applications/application-detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "continue",
                "path": "/applications/continue",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__applications__continue' */'D:/a/1/s/src/pages/applications/continue'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "details",
                "path": "/applications/bulkRequestTask/:id",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__applications__BulkTaskDetail' */'D:/a/1/s/src/pages/applications/BulkTaskDetail'), loading: LoadingComponent}),
                "exact": true,
                "pattern": ":id"
              },
              {
                "name": "details",
                "path": "/applications/:id",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__applications__application-detail' */'D:/a/1/s/src/pages/applications/application-detail'), loading: LoadingComponent}),
                "exact": true,
                "pattern": ":id"
              }
            ]
          },
          {
            "path": "/applications-classic",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__applications' */'D:/a/1/s/src/pages/applications'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "lists",
            "icon": "List",
            "path": "/custom-lists",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lists__Home' */'D:/a/1/s/src/pages/lists/Home'), loading: LoadingComponent}),
            "exact": false,
            "routes": [
              {
                "name": "groups",
                "path": "/custom-lists",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lists__index' */'D:/a/1/s/src/pages/lists/index'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "byGroup",
                "path": "/custom-lists/byGroup",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lists__byGroup' */'D:/a/1/s/src/pages/lists/byGroup'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": false
              },
              {
                "name": "list-builder",
                "path": "/custom-lists/:id/builder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lists__list-builder' */'D:/a/1/s/src/pages/lists/list-builder'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "details",
                "path": "/custom-lists/view",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lists__byList' */'D:/a/1/s/src/pages/lists/byList'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": false
              },
              {
                "name": "details-classic",
                "path": "/custom-lists/view-classic",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lists__byList-classic' */'D:/a/1/s/src/pages/lists/byList-classic'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": false
              }
            ]
          },
          {
            "name": "reports",
            "icon": "Insert-chart",
            "path": "/reports",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__reports__Home' */'D:/a/1/s/src/pages/reports/Home'), loading: LoadingComponent}),
            "hideChildrenInMenu": true,
            "routes": [
              {
                "name": "details",
                "path": "/reports/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__reports___reports' */'D:/a/1/s/src/pages/reports/_reports'), loading: LoadingComponent}),
                "exact": true,
                "pattern": ":id"
              },
              {
                "name": "details",
                "path": "/reports/:id/:reportId",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__reports__report-detail' */'D:/a/1/s/src/pages/reports/report-detail'), loading: LoadingComponent}),
                "exact": true,
                "pattern": ":reportId"
              }
            ]
          },
          {
            "name": "connections",
            "icon": "Settings-input-component",
            "path": "/connections",
            "authority": [
              "adminSection",
              "processGroupManage",
              "admin",
              "super-admin",
              "collaborator"
            ],
            "key": "connections",
            "hideChildrenInMenu": true,
            "routes": [
              {
                "name": "connections",
                "path": "/connections",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__connections__Home' */'D:/a/1/s/src/pages/connections/Home'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "callback",
                "path": "/connections/callback",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__connections__callback' */'D:/a/1/s/src/pages/connections/callback'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "groups",
                "path": "/connections/groups",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__connections__connection-group' */'D:/a/1/s/src/pages/connections/connection-group'), loading: LoadingComponent}),
                "authority": [
                  "adminSection",
                  "processGroupManage",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Errors__404' */'D:/a/1/s/src/components/Errors/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "apps",
            "icon": "Apps",
            "path": "/apps",
            "hideChildrenInMenu": true,
            "exact": false,
            "routes": [
              {
                "path": "/apps",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__apps__Home' */'D:/a/1/s/src/pages/apps/Home'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "builder",
                "path": "/apps/:id/builder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__apps__app-builder' */'D:/a/1/s/src/pages/apps/app-builder'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "agents",
            "icon": "Support-agent",
            "path": "/agents",
            "authority": [
              "adminSection",
              "admin",
              "super-admin",
              "collaborator"
            ],
            "hideChildrenInMenu": true,
            "exact": false,
            "routes": [
              {
                "path": "/agents",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration-agents__Home' */'D:/a/1/s/src/pages/administration-agents/Home'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "builder",
                "path": "/agents/:id/builder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__administration-agents__agent-builder' */'D:/a/1/s/src/pages/administration-agents/agent-builder'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "processes",
            "icon": "Device-hub",
            "path": "/administration/processes",
            "authority": [
              "adminSection",
              "processGroupManage",
              "admin",
              "super-admin"
            ],
            "hideChildrenInMenu": true,
            "hideInMenu": true,
            "routes": [
              {
                "name": "config",
                "path": "/administration/processes/config",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config' */'D:/a/1/s/src/pages/Process/process-config'), loading: LoadingComponent}),
                "exact": true,
                "pattern": ":id"
              },
              {
                "name": "actions",
                "path": "/administration/processes/config/actions",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions' */'D:/a/1/s/src/pages/Process/process-config/actions'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/email-template",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__email-template' */'D:/a/1/s/src/pages/Process/process-config/actions/config/email-template'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/filter-by-external-users",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__filter-by-external-users' */'D:/a/1/s/src/pages/Process/process-config/actions/config/filter-by-external-users'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/custom-notifications",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__custom-notifications' */'D:/a/1/s/src/pages/Process/process-config/actions/config/custom-notifications'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/notifications-mapping-attachments",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__notification-attachment-mapping' */'D:/a/1/s/src/pages/Process/process-config/actions/config/notification-attachment-mapping'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/pdf-template-generation-mapping",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__pdf-template-generation-mapping' */'D:/a/1/s/src/pages/Process/process-config/actions/config/pdf-template-generation-mapping'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/webhook-mapping",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__webhook-mapping' */'D:/a/1/s/src/pages/Process/process-config/actions/config/webhook-mapping'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/digital-signature-field-mapping",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__digital-signature-field-mapping' */'D:/a/1/s/src/pages/Process/process-config/actions/config/digital-signature-field-mapping'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/response-status",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__response-status' */'D:/a/1/s/src/pages/Process/process-config/actions/config/response-status'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/api-call-send",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__api-call-send' */'D:/a/1/s/src/pages/Process/process-config/actions/config/api-call-send'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/api-call-response",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__api-call-response' */'D:/a/1/s/src/pages/Process/process-config/actions/config/api-call-response'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/set-variable",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__set-variable' */'D:/a/1/s/src/pages/Process/process-config/actions/config/set-variable'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "config",
                "path": "/administration/processes/config/action/set-form-field-value",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config__actions__config__set-form-field-value' */'D:/a/1/s/src/pages/Process/process-config/actions/config/set-form-field-value'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/administration/processes/config/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config' */'D:/a/1/s/src/pages/Process/process-config'), loading: LoadingComponent}),
                "exact": true,
                "pattern": ":id"
              },
              {
                "path": "/administration/processes/config/:id/:action",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__process-config' */'D:/a/1/s/src/pages/Process/process-config'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "documents",
            "icon": "Documents",
            "path": "/documents",
            "authority": [
              "adminSection",
              "processGroupManage",
              "admin",
              "super-admin",
              "collaborator"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__documents' */'D:/a/1/s/src/pages/documents'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "entities",
            "icon": "Dns",
            "path": "/entities",
            "authority": [
              "adminSection",
              "processGroupManage",
              "admin",
              "super-admin",
              "support",
              "collaborator"
            ],
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Entities__Home' */'D:/a/1/s/src/pages/Entities/Home'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "byGroup",
                "path": "/entities/byGroup",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Entities__byGroup' */'D:/a/1/s/src/pages/Entities/byGroup'), loading: LoadingComponent}),
                "exact": true,
                "hideInMenu": true
              },
              {
                "name": "entity-builder",
                "path": "/entities/:id/builder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Entities__Configuration__entity-builder' */'D:/a/1/s/src/pages/Entities/Configuration/entity-builder'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "manage-entities",
                "path": "/entities/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Entities__ManageEntities' */'D:/a/1/s/src/pages/Entities/ManageEntities'), loading: LoadingComponent}),
                "hideInMenu": true,
                "pattern": ":id",
                "exact": true
              }
            ]
          },
          {
            "name": "configuration",
            "icon": "Settings",
            "path": "/configuration",
            "authority": [
              "adminSection",
              "processGroupManage",
              "user-admin",
              "admin",
              "super-admin"
            ],
            "hideChildrenInMenu": true,
            "key": "configuration",
            "routes": [
              {
                "name": "users",
                "path": "/configuration/users",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__users' */'D:/a/1/s/src/pages/configurations/users'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "user-devices",
                "path": "/configuration/user-devices",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__user-devices' */'D:/a/1/s/src/pages/configurations/user-devices'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "extra-user-fields",
                "path": "/configuration/extra-user-fields",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__extra-user-fields' */'D:/a/1/s/src/pages/configurations/extra-user-fields'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "users-groups",
                "path": "/configuration/users-groups",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__user-groups' */'D:/a/1/s/src/pages/configurations/user-groups'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "process-group",
                "path": "/configuration/process-group",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__process-group' */'D:/a/1/s/src/pages/configurations/process-group'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "positions",
                "path": "/configuration/positions",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__positions' */'D:/a/1/s/src/pages/configurations/positions'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "media",
                "path": "/configuration/media",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__media' */'D:/a/1/s/src/pages/configurations/media'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "media-categories",
                "path": "/configuration/media-categories",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__media-categories' */'D:/a/1/s/src/pages/configurations/media-categories'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "areas",
                "path": "/configuration/areas",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__areas' */'D:/a/1/s/src/pages/configurations/areas'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "approvers",
                "path": "/configuration/approvers",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers' */'D:/a/1/s/src/pages/approvers'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "routes": [
                  {
                    "name": "userGroup",
                    "path": "/configuration/approvers/GlobalUserGroupApproverUser",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers__manage-approver-user-group' */'D:/a/1/s/src/pages/approvers/manage-approver-user-group'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "groupAndPosition",
                    "path": "/configuration/approvers/GlobalUserGroupApproverByPosition",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers__manage-user-group-approver-position' */'D:/a/1/s/src/pages/approvers/manage-user-group-approver-position'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "entity",
                    "path": "/configuration/approvers/GlobalEntityApproverUser",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers__manage-approver-entity-user' */'D:/a/1/s/src/pages/approvers/manage-approver-entity-user'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "entityAndUserGroup",
                    "path": "/configuration/approvers/GlobalEntityApproverByUserGroup",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers__manage-approver-entity-user-group' */'D:/a/1/s/src/pages/approvers/manage-approver-entity-user-group'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "entityAndPosition",
                    "path": "/configuration/approvers/GlobalEntityApproverByPosition",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers__manage-approver-entity-position' */'D:/a/1/s/src/pages/approvers/manage-approver-entity-position'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "globalUserGroupAndArea",
                    "path": "/configuration/approvers/GlobalUserGroupApproverByArea",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers__manage-user-global-group-approver-area' */'D:/a/1/s/src/pages/approvers/manage-user-global-group-approver-area'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "globalEntityAndArea",
                    "path": "/configuration/approvers/GlobalEntityApproverByArea",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__approvers__manage-approver-global-entity-area' */'D:/a/1/s/src/pages/approvers/manage-approver-global-entity-area'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "name": "reports-tokens",
                "path": "/configuration/reports-tokens",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__report-tokens' */'D:/a/1/s/src/pages/configurations/report-tokens'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "reports",
                "path": "/configuration/reports",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__reports' */'D:/a/1/s/src/pages/configurations/reports'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "custom-list-groups",
                "path": "/configuration/custom-list-groups",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__custom-list-groups' */'D:/a/1/s/src/pages/configurations/custom-list-groups'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "ai-agent-teams",
                "path": "/configuration/ai-agent-teams",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__ai-agent-teams' */'D:/a/1/s/src/pages/configurations/ai-agent-teams'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "ai-skill-groups",
                "path": "/configuration/ai-skill-groups",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__ai-skill-groups' */'D:/a/1/s/src/pages/configurations/ai-skill-groups'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "dynamic-entity-groups",
                "path": "/configuration/dynamic-entity-groups",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__dynamic-entity-groups' */'D:/a/1/s/src/pages/configurations/dynamic-entity-groups'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "connection-group",
                "path": "/configuration/connection-group",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__connection-group' */'D:/a/1/s/src/pages/configurations/connection-group'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "power-bi-server",
                "path": "/configuration/power-bi-server",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__power-bi-server' */'D:/a/1/s/src/pages/configurations/power-bi-server'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "email-formats",
                "path": "/configuration/email-formats",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__email-formats' */'D:/a/1/s/src/pages/configurations/email-formats'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "environments",
                "path": "/configuration/environments",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__environments' */'D:/a/1/s/src/pages/configurations/environments'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "process-portal",
                "path": "/configuration/process-portal",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__process-portal' */'D:/a/1/s/src/pages/configurations/process-portal'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "reports-groups",
                "path": "/configuration/reports-groups",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__report-groups' */'D:/a/1/s/src/pages/configurations/report-groups'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "delegations",
                "path": "/configuration/delegations",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__delegations' */'D:/a/1/s/src/pages/configurations/delegations'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "shortenedUrl",
                "path": "/configuration/shortened-urls",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__shortened-urls' */'D:/a/1/s/src/pages/configurations/shortened-urls'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "usage",
                "path": "/configuration/usage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__usage' */'D:/a/1/s/src/pages/configurations/usage'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "aiConsumptions",
                "path": "/configuration/ai-consumptions",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__ai-consumptions' */'D:/a/1/s/src/pages/configurations/ai-consumptions'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "accessLog",
                "path": "/configuration/access-log",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__access-log' */'D:/a/1/s/src/pages/configurations/access-log'), loading: LoadingComponent}),
                "authority": [
                  "user-admin",
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "traces",
                "path": "/configuration/traces",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__traces' */'D:/a/1/s/src/pages/configurations/traces'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "email-traces",
                "path": "/configuration/email-traces",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__EmailMessageTraces' */'D:/a/1/s/src/pages/configurations/EmailMessageTraces'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "teams-message-traces",
                "path": "/configuration/teams-message-traces",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__teams-message-traces' */'D:/a/1/s/src/pages/configurations/teams-message-traces'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "sms-message-traces",
                "path": "/configuration/sms-message-traces",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__sms-message-traces' */'D:/a/1/s/src/pages/configurations/sms-message-traces'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "sequence",
                "path": "/configuration/sequence",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__sequences' */'D:/a/1/s/src/pages/configurations/sequences'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "administration",
                "path": "/configuration/administration",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration' */'D:/a/1/s/src/pages/Administration'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "access-policies",
                "path": "/configuration/access-policies",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__access-policies' */'D:/a/1/s/src/pages/configurations/access-policies'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "ai-billing",
                "path": "/configuration/ai-billing",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__ai-billing' */'D:/a/1/s/src/pages/configurations/ai-billing'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "white-label",
                "path": "/configuration/white-label",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__white-label' */'D:/a/1/s/src/pages/configurations/white-label'), loading: LoadingComponent}),
                "authority": [
                  "admin",
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-onboarding",
                "path": "/configuration/channel-onboarding",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-onboarding' */'D:/a/1/s/src/pages/configurations/channel-onboarding'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "billing-subscriptions",
                "path": "/configuration/billing-subscriptions",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__billing-subscriptions' */'D:/a/1/s/src/pages/configurations/billing-subscriptions'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-distributors",
                "path": "/configuration/channel-distributors",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-distributors' */'D:/a/1/s/src/pages/configurations/channel-distributors'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-partners",
                "path": "/configuration/channel-partners",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-partners' */'D:/a/1/s/src/pages/configurations/channel-partners'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-resellers",
                "path": "/configuration/channel-resellers",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-resellers' */'D:/a/1/s/src/pages/configurations/channel-resellers'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-referral-agents",
                "path": "/configuration/channel-referral-agents",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-referral-agents' */'D:/a/1/s/src/pages/configurations/channel-referral-agents'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-customer-assignments",
                "path": "/configuration/channel-customer-assignments",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-customer-assignments' */'D:/a/1/s/src/pages/configurations/channel-customer-assignments'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-agreements",
                "path": "/configuration/channel-agreements",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-agreements' */'D:/a/1/s/src/pages/configurations/channel-agreements'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "name": "channel-plans",
                "path": "/configuration/channel-plans",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__configurations__channel-plans' */'D:/a/1/s/src/pages/configurations/channel-plans'), loading: LoadingComponent}),
                "authority": [
                  "super-admin"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Errors__404' */'D:/a/1/s/src/components/Errors/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Errors__404' */'D:/a/1/s/src/components/Errors/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
